import styled from "styled-components";

const InventoriesPageStyled = styled.div`

`;

export default InventoriesPageStyled;